import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { 
  FileText, Calendar, GitBranch, CheckCircle2
} from "lucide-react";
import { TrustNavigation } from "@/components/TrustNavigation";
import { TrustFooter } from "@/components/TrustFooter";
import changeLogData from "@/data/change-log.json";

export default function ChangeLog() {

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#05070a", color: "#ffffff" }}>
      <TrustNavigation currentPath="/change-log" />

      <section className="relative overflow-hidden bg-slate-900">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-950" />
        <div className="container mx-auto px-4 py-16 md:py-24 relative">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 text-white rounded-full text-sm font-medium border border-white/20 mb-6">
              <GitBranch className="w-4 h-4" />
              <span>Change Log</span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              Platform Updates
            </h1>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              Version history and changelog for platform features, policies, and documentation updates.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="relative">
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-slate-300" />
              
              <div className="space-y-8">
                {changeLogData.map((release, idx) => (
                  <div key={release.version} className="relative pl-12">
                    <div className="absolute left-0 w-8 h-8 bg-slate-900 rounded-full flex items-center justify-center">
                      <GitBranch className="w-4 h-4 text-white" />
                    </div>
                    
                    <Card className={`p-6 shadow-sm ${idx === 0 ? 'border-white/10 bg-slate-800/30' : 'bg-slate-800/30 border-white/10'}`}>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-4">
                        <div className="flex items-center gap-3">
                          <span className="text-lg font-bold text-white">
                            v{release.version}
                          </span>
                          {idx === 0 && (
                            <span className="text-xs bg-slate-900 text-white px-2 py-0.5 rounded-full font-medium">
                              Latest
                            </span>
                          )}
                        </div>
                        <div className="flex items-center gap-1 text-sm text-slate-400">
                          <Calendar className="w-4 h-4" />
                          <span>{release.date}</span>
                        </div>
                      </div>
                      
                      <p className="font-medium mb-4 text-slate-300">
                        {release.summary}
                      </p>
                      
                      <ul className="space-y-2">
                        {release.changes.map((change, cIdx) => (
                          <li key={cIdx} className="flex items-start gap-2 text-sm text-slate-400">
                            <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5 text-green-600" />
                            <span>{change}</span>
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrustFooter />
    </div>
  );
}
